import React from "react";
import * as palette from "@govlaunch/palette";
import { LinkedinIcon, TwitterIcon, FacebookIcon } from "react-share";
import InstagramIcon from "~/components/icons/InstagramIcon";
import YoutubeIcon from "~/components/icons/YoutubeIcon";
import { Anchor } from "@govlaunch/web";
import { FormattedMessage } from "react-intl";

interface IFollowUs {
  socialMedia?: ISocialMedia | null;
  size?: number;
}

interface ISocialMedia {
  linkedin?: string | null;
  twitter?: string | null;
  facebook?: string | null;
  instagram?: string | null;
  youtube?: string | null;
}

const FollowUs: React.FunctionComponent<IFollowUs> = ({ socialMedia, size = 31 }) => {
  if (
    !socialMedia ||
    (!socialMedia.instagram &&
      !socialMedia.youtube &&
      !socialMedia.linkedin &&
      !socialMedia.linkedin &&
      !socialMedia.facebook)
  ) {
    return null;
  }

  return (
    <div
      css={{
        marginLeft: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <span
        css={{
          fontSize: 16,
          fontWeight: "bold",
          color: palette.text,
          marginBottom: 6,
        }}
      >
        <FormattedMessage defaultMessage="Follow Us" id="HyMKMD" />
      </span>

      {socialMedia && (
        <div
          css={{
            display: "grid",
            gridAutoFlow: "column",
            gridColumnGap: 14,
          }}
        >
          {socialMedia.linkedin && (
            <Anchor href={socialMedia.linkedin} external="outside-redirect">
              <LinkedinIcon size={size} round={true} />
            </Anchor>
          )}
          {socialMedia.twitter && (
            <Anchor href={socialMedia.twitter} external="outside-redirect">
              <TwitterIcon size={size} round={true} />
            </Anchor>
          )}
          {socialMedia.facebook && (
            <Anchor href={socialMedia.facebook} external="outside-redirect">
              <FacebookIcon size={size} round={true} />
            </Anchor>
          )}
          {socialMedia.instagram && (
            <Anchor href={socialMedia.instagram} external="outside-redirect">
              <InstagramIcon height={size} width={size} />
            </Anchor>
          )}
          {socialMedia.youtube && (
            <Anchor
              href={socialMedia.youtube}
              external="outside-redirect"
              css={{
                height: size,
                width: size + 7,
              }}
            >
              <YoutubeIcon height={size} width={size + 7} />
            </Anchor>
          )}
        </div>
      )}
    </div>
  );
};

export default FollowUs;
